import { message } from 'antd';

import { call, put, takeEvery, all, fork, select, takeLatest } from 'redux-saga/effects'
import { getSubmittedToTypistAPI } from '../../../services/mis-service';
import { FETCH_SUBMITTED_TO_TYPIST, FETCH_SUBMITTED_TO_TYPIST_ERROR, FETCH_SUBMITTED_TO_TYPIST_START, FETCH_SUBMITTED_TO_TYPIST_SUCCESS, 
    SET_SUBMITTED_TO_TYPIST_FILTER, SET_SUBMITTED_TO_TYPIST_PAGINATION } from '../../actions/mis/submittedToTypistAction';

function* fetchSubmittedToTypist({ payload }) {
    try {
        yield put({ type: FETCH_SUBMITTED_TO_TYPIST_START })
        const response = yield call(getSubmittedToTypistAPI, payload);
        if (response.success) {
            const pagination = {
                currentPage: payload.page,
                pageSize: payload.size,
                totalPages: response.data.totalPages,
                totalItems: response.data.totalItems,
            }
            yield put({ type: FETCH_SUBMITTED_TO_TYPIST_SUCCESS, submittedToTypist: response.data.misSubmittedToTypist });
            yield put({ type: SET_SUBMITTED_TO_TYPIST_PAGINATION, pagination });
            yield put({ type: SET_SUBMITTED_TO_TYPIST_FILTER, payload: { ...payload } });

        } else {
            yield put({ type: FETCH_SUBMITTED_TO_TYPIST_ERROR, error: response.error })
            message.error('Failed to fetch submitted to typist visits!');
        }
    } catch (error) {
        yield put({ type: FETCH_SUBMITTED_TO_TYPIST_ERROR, error })
        message.error('Failed to fetch submitted to typist visits!');
    }
}

function* misSubmittedToTypistWatcher() {
    yield takeEvery(FETCH_SUBMITTED_TO_TYPIST, fetchSubmittedToTypist)
}

export default function* rootSaga() {
    yield all([
        misSubmittedToTypistWatcher(),
    ]);
}